<script>
  import { fade } from "svelte/transition";
  import { loading } from "$lib/state/loader";
  import { afterUpdate } from "svelte";
  import { bodyScroll } from "$lib/utils/PreventBodyScroll";

  /** @type {number}*/
  let timer;

  $: if ($loading.status === "NAVIGATING") {
    timer = setTimeout(() => {
      if ($loading.status === "NAVIGATING") {
        $loading.status = "LOADING";
        bodyScroll.prevent();
      }
    }, 200);
  }
  $: {
    $loading;
    afterUpdate(() => {
      if ($loading.status === "IDLE") {
        bodyScroll.allow();
        clearTimeout(timer);
      }
    });
  }

</script>

<div class="inactive" class:active={$loading.status === "LOADING"}>
  <div class="loading" transition:fade>
    <div class="wrapper">
      <div class="circle"></div>
      <div class="circle"></div>
      <div class="circle"></div>
      <div class="shadow"></div>
      <div class="shadow"></div>
      <div class="shadow"></div>
    </div>
  </div>
</div>

<style>
  .inactive {
    width: 100svw;
    height: 100svh;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99999999999999;
    background-color: #fdfdfd;
    opacity: 0;
    transition: all 0.5s ease;
    user-select: none;
    pointer-events: none;
  }
  .active {
    opacity: 1;
    pointer-events: all !important;
  }
  .loading {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .wrapper {
    width: 180px;
    height: 60px;
    position: relative;
    z-index: 1;
    margin: 0 auto;
  }

  .circle {
    width: 35px;
    height: 35px;
    position: absolute;
    border-radius: 50%;
    background-color: var(--orange);
    left: 0;
    transform-origin: 50%;
    animation: circle7124 450ms alternate infinite ease;
    z-index: 1;
  }
  @keyframes circle7124 {
    0% {
      top: 60px;
      height: 3px;
      border-radius: 50px 50px 25px 25px;
      transform: scaleX(1.8);
    }

    40% {
      height: 25px;
      border-radius: 50%;
      transform: scaleX(1);
    }

    100% {
      top: 0%;
    }
  }
  .circle:nth-child(2) {
    left: 75px;
    animation-delay: 200ms;
  }
  .circle:nth-child(3) {
    left: auto;
    right: 0;
    animation-delay: 300ms;
  }
  .shadow {
    width: 35px;
    height: 12px;
    border-radius: 50%;
    background-color: rgba(0, 0, 0, 0.9);
    position: absolute;
    top: 60px;
    transform-origin: 50%;
    z-index: -1;
    left: 0;
    filter: blur(1px);
    animation: shadow046 450ms alternate infinite ease;
  }
  @keyframes shadow046 {
    0% {
      transform: scaleX(1.5);
    }

    40% {
      transform: scaleX(1);
      opacity: 0.7;
    }

    100% {
      transform: scaleX(0.2);
      opacity: 0.4;
    }
  }
  .shadow:nth-child(4) {
    left: 75px;
    animation-delay: 200ms;
  }
  .shadow:nth-child(5) {
    left: auto;
    right: 0;
    animation-delay: 300ms;
  }
</style>
